var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAiChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Ai chat",
    clipPath: "url(#clip0_984_757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 6",
    d: "M17.2634 2.01362C17.3405 1.78801 17.6595 1.788 17.7366 2.01362L18.2862 3.6232C18.4613 4.13594 18.8641 4.53867 19.3768 4.71376L20.9864 5.26341C21.212 5.34046 21.212 5.65954 20.9864 5.73659L19.3768 6.28624C18.8641 6.46133 18.4613 6.86406 18.2862 7.3768L17.7366 8.98639C17.6595 9.21199 17.3405 9.212 17.2634 8.98638L16.7138 7.3768C16.5387 6.86406 16.1359 6.46133 15.6232 6.28624L14.0136 5.73659C13.788 5.65954 13.788 5.34046 14.0136 5.26341L15.6232 4.71376C16.1359 4.53867 16.5387 4.13594 16.7138 3.6232L17.2634 2.01362Z",
    stroke: "#1976D2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 10V15.5C21 16.0304 20.7893 16.5391 20.4142 16.9142C20.0391 17.2893 19.5304 17.5 19 17.5H10.3613C9.49622 17.5 8.67324 17.8734 8.10357 18.5245L5.5 21.5V18.3559C5.5 17.8545 5.15483 17.4191 4.66667 17.3047V17.3047C3.69035 17.076 3 16.2052 3 15.2024V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H10.5",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_984_757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiChat);
export default __webpack_public_path__ + "static/media/icon_ai_chat.a0c52d500a39043fd51d36a5eba57b08.svg";
export { ForwardRef as ReactComponent };